/* eslint-disable react-hooks/exhaustive-deps */
import React, {  useEffect, useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Grid,
  InputAdornment,
  TextField,
  LinearProgress,
  Typography,
  Modal,
  IconButton,
  Snackbar,
  Alert,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import CloseIcon from "@mui/icons-material/Close";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import "./style.css";
import { ZyppLiteApi } from "../../../API/Zypp-Lite-Api/LiteApi";
const FleetDailyReport = () => {
  const [searchValInputRideEnd, setSearchValInputRideEnd] = useState("");
  const [pageRideEnd, setPageRideEnd] = useState(0);
  const [totalCountRideEnd, setTotalCountRideEnd] = useState<any>();
  const [rideEndListData, setRideEndListData] = useState<any[]>([]);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [showErrorSnackbar, setShowErrorSnackbar] = useState(false);
  const [showSuccessSnackbar, setShowSuccessSnackbar] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [rejectConfirmOpen, setRejectConfirmOpen] = useState(false);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const  rowsPerPage = 10;
  const pageRangeRideEnd = 5;


  const tableHeaderCellStyle = {
    fontWeight: 600,
    fontSize: "14px",
    color: "#455A64",
    font: "Rubik",
  };
  const tableBodyCellStyle = {
    fontWeight: 400,
    fontSize: "14px",
    color: "#3b3b3b",
    font: "Rubik",
  };
  // Dummy data for tables

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>, item: any) => {
    setAnchorEl(event.currentTarget);
    setSelectedItem(item);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleRideEndClick = () => {
    handleMenuClose();
    setConfirmOpen(true);
  };

  const handleRejectClick = () => {
    handleMenuClose();
    setRejectConfirmOpen(true);
  };

  const handleUserSelect = (item: any) => {
    ZyppLiteApi.api?.userRiderEnd(item.userId)
      .then((response) => {
        if (response?.code === 2000) {
          handleOpen();
          setOpen(true);
          setTimeout(() => {
            setOpen(false);
            window.location.reload();
          }, 5000);
        } else {
          setSnackbarMessage(response?.message || "Error ending ride");
          setShowErrorSnackbar(true);
        }
      })
      .catch((error) => {
        console.error("API call error:", error);
        if (error.response) {
          setSnackbarMessage(error.response.data?.message || "Failed to end ride. Please try again.");
        } else {
          setSnackbarMessage("Network error or server unreachable.");
        }
        setShowErrorSnackbar(true);
      });
  };

  const handleRejectRideEnd = (item: any) => {
    ZyppLiteApi.api?.rejectRideEndRequest(item.userId)
      .then((response) => {
        if (response?.code === 2000) {
          setSnackbarMessage("Ride end request rejected successfully!");
          setShowSuccessSnackbar(true);
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        } else {
          setSnackbarMessage(response?.message || "Error rejecting ride end request");
          setShowErrorSnackbar(true);
        }
      })
      .catch((error) => {
        console.error("API call error:", error);
        if (error.response) {
          setSnackbarMessage(error.response.data?.message || "Failed to reject ride end request. Please try again.");
        } else {
          setSnackbarMessage("Network error or server unreachable.");
        }
        setShowErrorSnackbar(true);
      });
  };
  
  
  const pageCountRideEnd = Math.ceil(totalCountRideEnd / rowsPerPage);

  const handlePageChangeRideEnd = (newPage: number) => {
   
    const newPageNumber = Math.max(1, Math.min(newPage + 1, pageCountRideEnd));
    setPageRideEnd(newPageNumber - 1);
  };
  function getStatusColor(status: boolean) {
    if (status === true) {
      return "#CFFFEF"; // active
    } else if (status === false)  {
      return "#FFD7D2"; // inactive
    } 
    // Default color
    return "";
  }
  
  function getStatusTextColor(status: boolean) {
    if (status === true) {
      return "#05B97D"; // active
    } else if (status === false)  {
      return "#F94932"; // inactive
    } 
    // Default text color
    return "";
  }
  
  function getStatusText(status: boolean): string {
    if (status === true) {
      return "Active";
    } else if (status === false) {
      return "Inactive";
    } 
    // Default status text
    return "";
  }
  
 
  
  const renderPageNumbersRideEnd = () => {
   
    const pagesToShow = Math.min(pageCountRideEnd, pageRangeRideEnd);
    const startPage = Math.max(
      0,
      Math.min(pageRideEnd - Math.floor(pageRangeRideEnd / 2), pageCountRideEnd - pagesToShow)
    );

    return Array.from({ length: pagesToShow }, (_, index) => {
      const pageNumber = startPage + index + 1;
      return (
        <span
          key={index}
          onClick={() => handlePageChangeRideEnd(pageNumber - 1)}
          className={pageRideEnd === pageNumber - 1 ? "active" : "unactive"}
          style={{ marginLeft: "6px" }}
        >
          {pageNumber}
        </span>
      );
    });
  };
  
  const handleClearSearch = () => {
    setSearchValInputRideEnd("");
  };
  
  
  
  useEffect(() => {
    ZyppLiteApi.api?.riderEndList(searchValInputRideEnd, pageRideEnd, rowsPerPage)
      .then((response) => {
        if (response.data.usersDetails.length > 0) {
          setRideEndListData(response.data.usersDetails);
          setTotalCountRideEnd(response.data.total);

        } else {
          setRideEndListData([]);
          setTotalCountRideEnd(1);
        }
      })
      .catch((error) => {
        console.error("API call error: ", error);
      });
  }, [ rowsPerPage, searchValInputRideEnd, pageRideEnd]);

  return (
     <div className="p-10">
    
    <div className="w-full flex bg-white min-h-80 box-shadow p-3 rounded-xl mt-8">
      <div className="w-full">
        <Grid container spacing={5} className="w-full flex justify-between ">
          <Grid item md={6}>
            <div className="flex ml-4">
            <h2 className="text-center ml-2 mx-1 mt-2 font-semibold text-2xl text-black pb-2">
            Ride End Requests
              </h2>
            </div>
          </Grid>
          <Grid item md={6}>
            <div className="flex mr-4">
              <div className="flex w-full justify-end">
                <div className="mr-3">
                  <TextField
                    placeholder="Search  Vehicle Number"
                    id="outlined-basic"
                    variant="outlined"
                    onChange={(search: any) =>
                      setSearchValInputRideEnd(search.target.value)
                    }
                    value={searchValInputRideEnd}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment
                          position="end"
                          onClick={handleClearSearch}
                        >
                          <ClearIcon style={{ cursor: "pointer" }} />
                        </InputAdornment>
                      ),
                      style: { height: "40px", borderRadius: "25px" },
                    }}
                    // onKeyDown={handleKeyPress}
                  />
                </div>

                
               

              </div>
            </div>
          </Grid>
        </Grid>
        <hr className="my-4" />

        <TableContainer>
          {!rideEndListData ? ( // Check if API response is still undefined (loading)
            <LinearProgress />
          ) : typeof rideEndListData === "string" ? ( // If API returns "No Data Found" as a string
            <Typography style={{ textAlign: "center", padding: "10px" }}>
              No data available
            </Typography>
          ) : rideEndListData.length === 0 ? ( // If the array is empty
            <Typography style={{ textAlign: "center", padding: "10px" }}>
              No data available
            </Typography>
          ) : (
            <Table>
              <TableHead>
                <TableRow>
                <TableCell
                    style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                    sx={{ minWidth: 120 }}
                  >
                     Vehicle No
                  </TableCell>
                  <TableCell
                    style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                    sx={{ minWidth: 120 }}
                  >
                    Employee Id
                  </TableCell>
                  <TableCell
                    style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                    sx={{ minWidth: 150 }}
                  >
                    Name
                  </TableCell>
                  <TableCell
                    style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                    sx={{ minWidth: 110 }}
                  >
                    Mobile
                  </TableCell>
                 
                  <TableCell
                    style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                    sx={{ minWidth: 100 }}
                  >
                    Status
                  </TableCell>
                  <TableCell
                    style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                    sx={{ minWidth: 100 }}
                  >
                    Action
                  </TableCell>
                 
                </TableRow>
              </TableHead>
              <TableBody>
                {rideEndListData.map(
                  (item: any, index: any) => (
                    <TableRow key={index}>
                       <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        {item.vehicleNo}
                      </TableCell>
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        {item.clientEmployeeId}
                      </TableCell>
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        {item.name}
                      </TableCell>
                     
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        {item.mobile}
                      </TableCell>
                      
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        <span
                            style={{
                              backgroundColor: getStatusColor(item.isActive),
                              color: getStatusTextColor(item.isActive),
                              paddingInline: "18px",
                              paddingBlock: "4px",
                              borderRadius: "14px",
                              width: "100px",
                              font: "Rubik",
                              fontSize: "14px",
                            }}
                          >
                            {getStatusText(item.isActive)}
                          </span>
                      </TableCell>
                      <TableCell style={{ textAlign: "center" }}>
                        <IconButton
                          onClick={(e) => handleMenuOpen(e, item)}
                          sx={{
                            backgroundColor: "#f5f5f5",
                            border: "1px solid #e0e0e0",
                            borderRadius: "8px",
                            padding: "8px",
                            "&:hover": {
                              backgroundColor: "#eeeeee",
                            },
                          }}
                        >
                          <MoreVertIcon sx={{ color: "#455A64" }} />
                        </IconButton>
                      </TableCell>
                      
                    </TableRow>
                  )
                )}
              </TableBody>
            </Table>
          )}
        </TableContainer>

        {/* Action Menu */}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          PaperProps={{
            sx: {
              borderRadius: "12px",
              boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
              minWidth: "180px",
            },
          }}
        >
          <MenuItem onClick={handleRideEndClick} sx={{ py: 1.5 }}>
            <ListItemIcon>
              <CheckCircleOutlineIcon sx={{ color: "#4CAF50" }} />
            </ListItemIcon>
            <ListItemText
              primary="Ride End"
              primaryTypographyProps={{
                fontSize: "14px",
                fontFamily: "Rubik",
                fontWeight: 500,
              }}
            />
          </MenuItem>
          <MenuItem onClick={handleRejectClick} sx={{ py: 1.5 }}>
            <ListItemIcon>
              <CancelOutlinedIcon sx={{ color: "#F44336" }} />
            </ListItemIcon>
            <ListItemText
              primary="Reject Ride End"
              primaryTypographyProps={{
                fontSize: "14px",
                fontFamily: "Rubik",
                fontWeight: 500,
              }}
            />
          </MenuItem>
        </Menu>

        <div className="pl-2 pt-4 pb-2 pr-16">
          <div
            className="pagination"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <div>
              <button
                onClick={() => handlePageChangeRideEnd(pageRideEnd - 1)}
                disabled={pageRideEnd === 0}
                style={{
                  fontFamily: "Rubik",
                  fontSize: "20px",
                  marginRight: "6px",
                }}
              >
                {"<"}
              </button>
              {renderPageNumbersRideEnd()}
              <button
                onClick={() => handlePageChangeRideEnd(pageRideEnd + 1)}
                disabled={pageRideEnd >= pageCountRideEnd - 1}
                style={{
                  fontFamily: "Rubik",
                  fontSize: "20px",
                  marginLeft: "6px",
                }}
              >
                {">"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 350,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: "8px",
            textAlign: "center",
          }}
        >
           <IconButton
            sx={{ position: "absolute", top: 8, right: 8 }}
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
          <Box
            sx={{
              width: 60,
              height: 60,
              backgroundColor: "#00C853",
              borderRadius: "50%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              margin: "auto",
            }}
          >
            <Typography sx={{ fontSize: 40, color: "white" }}>✔</Typography>
          </Box>
          <Typography variant="h6" sx={{ mt: 2 }}>
            Ride Ended Successfully!
          </Typography>
          <Button
            variant="contained"
            sx={{ mt: 3, backgroundColor: "#000", color: "#fff", borderRadius:'40px' }}
            onClick={handleClose}
          >
            Continue to Dashboard
          </Button>
        </Box>
      </Modal>
      <Modal open={confirmOpen} onClose={() => setConfirmOpen(false)}>
  <Box
    sx={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 400,
      bgcolor: "background.paper",
      boxShadow: 24,
      p: 4,
      borderRadius: "12px",
      textAlign: "center",
    }}
  >
    <Typography variant="h6" sx={{ mb: 2 }}>
      Are you sure?
    </Typography>

    <Typography sx={{ color: "#555", mb: 3 }}>
      Do you really want to end this ride?
    </Typography>

    <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
      <Button
        variant="outlined"
        sx={{ borderRadius: "30px" }}
        onClick={() => setConfirmOpen(false)}
      >
        Cancel
      </Button>

      <Button
        variant="contained"
        sx={{
          backgroundColor: "#000",
          color: "#fff",
          borderRadius: "30px",
        }}
        onClick={() => {
          setConfirmOpen(false);
          handleUserSelect(selectedItem);
        }}
      >
        Accept
      </Button>
    </Box>
  </Box>
</Modal>

      {/* Reject Confirmation Modal */}
      <Modal open={rejectConfirmOpen} onClose={() => setRejectConfirmOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: "12px",
            textAlign: "center",
          }}
        >
          <Box
            sx={{
              width: 60,
              height: 60,
              backgroundColor: "#FFEBEE",
              borderRadius: "50%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              margin: "auto",
              mb: 2,
            }}
          >
            <CancelOutlinedIcon sx={{ fontSize: 32, color: "#F44336" }} />
          </Box>
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
            Reject Ride End Request?
          </Typography>

          <Typography sx={{ color: "#555", mb: 3 }}>
            Are you sure you want to reject this ride end request?
          </Typography>

          <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
            <Button
              variant="outlined"
              sx={{
                borderRadius: "30px",
                px: 3,
                borderColor: "#e0e0e0",
                color: "#333",
                "&:hover": {
                  borderColor: "#bdbdbd",
                  backgroundColor: "#fafafa",
                },
              }}
              onClick={() => setRejectConfirmOpen(false)}
            >
              Cancel
            </Button>

            <Button
              variant="contained"
              sx={{
                backgroundColor: "#F44336",
                color: "#fff",
                borderRadius: "30px",
                px: 3,
                "&:hover": {
                  backgroundColor: "#D32F2F",
                },
              }}
              onClick={() => {
                setRejectConfirmOpen(false);
                handleRejectRideEnd(selectedItem);
              }}
            >
              Reject
            </Button>
          </Box>
        </Box>
      </Modal>

      <Snackbar open={showErrorSnackbar} autoHideDuration={6000} onClose={() => setShowErrorSnackbar(false)}>
              <Alert severity="error">{snackbarMessage}</Alert>
            </Snackbar>
      <Snackbar open={showSuccessSnackbar} autoHideDuration={6000} onClose={() => setShowSuccessSnackbar(false)}>
              <Alert severity="success">{snackbarMessage}</Alert>
            </Snackbar>
    </div>
    
  );
};

export default FleetDailyReport;
